import * as ko from 'knockout';
import {Observable} from "~knockout/index";
import {ComputedOptions} from "~knockout/index";
import {Computed} from "~knockout/index";

export class Screen
{
    public visible: Computed<boolean>;

    constructor()
    {
        this.createBindings();
    }


    /**
     * create knockout bindings
     */
    createBindings()
    {
        this.visible = ko.computed(this.getVisibleOptions());

        this.visible.subscribe((visible: boolean) => this.onVisibilityChange(visible));
    }


    /**
     * get screen visibility computed options
     * @returns {null}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return;
    }


    /**
     * when this screen's visibility changes, do something
     */
    onVisibilityChange(visible: boolean)
    {
        visible ? this.onShow() : this.onHide();
    }


    /**
     * call a function when we show
     */
    onShow()
    {

    }


    onHide()
    {

    }
}


// WEBPACK FOOTER //
// ./src/ts/screens/Screen.ts